// IMPORTANT: this file (and imported here) should have .js extension, because it should work in IE

var detectIE = require("@cirrus/legacy/app-common/utils/browser-detecter.js").detectIE

function isBrowserSupported() {
  return !detectIE()
}

module.exports = {
  isBrowserSupported,
}
